import { Controller } from "@hotwired/stimulus"

// Polls url until it stops answering 202 Accepted, then swaps the response HTML into the
// content target. Gives up after timeout milliseconds.
// Waits back off like Fibonacci from interval (0.5s, 1s, 1.5s, 2.5s, 4s, ...) up to maxInterval.
export default class extends Controller {
  static targets = ["content"]
  static values = {
    url: String,
    interval: { type: Number, default: 500 },
    maxInterval: { type: Number, default: 4000 },
    timeout: { type: Number, default: 90000 }
  }

  connect() {
    this.startedAt = Date.now()
    this.previousDelay = 0
    this.delay = this.intervalValue
    this.schedule()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  schedule() {
    this.timer = setTimeout(this.poll, this.delay)
    const nextDelay = this.previousDelay ? this.previousDelay + this.delay : this.delay * 2
    this.previousDelay = this.delay
    this.delay = Math.min(nextDelay, this.maxIntervalValue)
  }

  poll = () => {
    fetch(this.urlValue, { headers: { Accept: "text/html" } })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to poll ${this.urlValue} (status ${response.status})`)
        }
        if (response.status === 202) {
          if (Date.now() - this.startedAt > this.timeoutValue) {
            throw new Error(`Timed out polling ${this.urlValue}`)
          }
          this.schedule()
          return
        }
        return response.text().then(html => { this.contentTarget.innerHTML = html })
      })
      .catch(error => {
        if (window.newrelic) { window.newrelic.noticeError(error) }
        this.contentTarget.innerHTML = '<div class="modal-body"><div class="alert alert-danger mb-0">Failed to load content. Please try again.</div></div>'
      })
  }
}
